import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { Layout } from '@/components/Layout';
import { Toaster } from 'sonner';

import HomePage from '@/pages/HomePage';
import LoginPage from '@/pages/LoginPage';
import ReportViolationPage from '@/pages/ReportViolationPage';
import ReportBlackspotPage from '@/pages/ReportBlackspotPage';
import MapDashboardPage from '@/pages/MapDashboardPage';
import MyReportsPage from '@/pages/MyReportsPage';
import AdminDashboardPage from '@/pages/AdminDashboardPage';
import LeaderboardPage from '@/pages/LeaderboardPage';
import DashboardPage from '@/pages/DashboardPage';
import BlogPage from '@/pages/BlogPage';
import SmartFeaturesPage from '@/pages/SmartFeaturesPage';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors closeButton />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/report/violation" element={<ReportViolationPage />} />
            <Route path="/report/blackspot" element={<ReportBlackspotPage />} />
            <Route path="/map" element={<MapDashboardPage />} />
            <Route path="/my-reports" element={<MyReportsPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/smart" element={<SmartFeaturesPage />} />
          </Routes>
        </Layout>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
